import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import Layout from '~/components/Layout';
import TableComponent from '~/components/TableComponent';
import { MilkMoneyQuery } from '~/QueryHooks/MilkMoneyQuery';
import { FiltersWrapper } from '../style';
import { Dropdown, Input } from 'semantic-ui-react';
import { useDebounce } from 'use-lodash-debounce';

const SwissMilkDelivery: React.FC = () => {
  const { t } = useTranslation()

  const defaultTableColumnHeaders = [
    {
      name: t('Date import'),
      key: 'createdAt',
      type: 'date',
      format: 'DD.MM.YYYY HH:mm',
      sorted: 'desc'
    },
    {
      name: t('Tour start'),
      key: 'dateStart',
      type: 'date',
      format: 'DD.MM.YYYY HH:MM',
      sorted: 'desc'
    },
    {
      name: t('Tour end'),
      key: 'dateEnd',
      type: 'date',
      format: 'DD.MM.YYYY HH:MM',
      sorted: 'desc'
    },
    {
      name: t('Collection truck no.'),
      key: 'vehicleNumber',
      sorted: 'desc'
    },
    {
      name: t('Tour no.'),
      key: 'tourNumber',
      sorted: 'desc'
    },
    {
      name: t('Driver no.'),
      key: 'driverNumber',
      sorted: 'desc'
    },
    {
      name: t('Total amount (in l)'),
      key: 'totalAmount',
      type: 'no-unit-number',
      decimalScale: 0,
      sorted: 'desc'
    },
    {
      name: t('Number of operations'),
      key: 'dataCount',
      sorted: 'desc'
    },
    {
      name: t('Number of samples'),
      key: 'samplesTotal',
      sorted: 'desc'
    }
  ]

  const [tableColumnHeaders, setTableColumnHeaders] = useState(defaultTableColumnHeaders)
  const [dataFiltered, setDataFiltered] = useState({
    rows: 20,
    page: 0,
    month: '',
    search: ''
  })
  const [search, setSearch] = useState('')
  const debouncedSearchValue = useDebounce(search, 300)

  const {
    data: tours,
    isLoading: isLoadingTours,
    refetch: fetchTours,
    isFetching: isFetchingTours
  } = MilkMoneyQuery.getTempTours({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  })

  const {
    data: toursOptions,
    isLoading: isLoadingToursOptions,
    refetch: fetchOptions
  } = MilkMoneyQuery.getTempToursOptions()

  useEffect(() => {
    setTableColumnHeaders(defaultTableColumnHeaders)
    fetchOptions()
  }, [t])

  useEffect(() => {
    fetchTours()
  }, [dataFiltered])

  useEffect(() => {
    setDataFiltered({ ...dataFiltered, search: debouncedSearchValue, page: 0 });
  }, [debouncedSearchValue]);

  useEffect(() => {
    if (toursOptions?.months?.length > 0 && !dataFiltered?.month) {
      setDataFiltered({
        ...dataFiltered,
        month: toursOptions?.months[0]?.key
      })
    }
  }, [toursOptions])

  function renderFilters() {
    return <FiltersWrapper>
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('EVS-Nr. /  Betriebsname')}
        value={search}
        onChange={(e, data) => setSearch(data.value)}
      />
      <Dropdown
        selection
        options={toursOptions?.months?.map(month => ({ value: month.key, text: month.label }))}
        value={dataFiltered.month}
        onChange={(_, { value }) => {
          setDataFiltered({
            ...dataFiltered,
            month: value as string
          })
        }}
        placeholder={t('Delivery month tour')}
      />
    </FiltersWrapper>
  }

  function renderTable() {
    return <TableComponent
      isFetchingData={isFetchingTours}
      animated
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data, tableColumnHeaders) => {
        setTableColumnHeaders(tableColumnHeaders)
        setDataFiltered(data)
      }}
      rows={rows}
      total={filtered}
    />
  }

  const { filtered, rows } = tours ? tours : { filtered: 0, rows: [] };

  return <Layout
    segmented
    isBusy={isLoadingTours || isLoadingToursOptions}
    title={t('Tour overview MSW')}
    filters={renderFilters()}
  >
    {renderTable()}
  </Layout>;

}
export default SwissMilkDelivery